import { render, staticRenderFns } from "./StoreCloseAgree.vue?vue&type=template&id=2562a94f&"
import script from "./StoreCloseAgree.vue?vue&type=script&lang=js&"
export * from "./StoreCloseAgree.vue?vue&type=script&lang=js&"
import style0 from "./StoreCloseAgree.vue?vue&type=style&index=0&id=2562a94f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports